import React, { useState, useEffect, useCallback } from 'react'
import Spiner from '../../components/General/Spiner'
import ConfiguracionLogic from '../../functions/logic/Configuracion'
import DynamicTable from '../../components/DataTables/DynamicTable'
import { useSnackbar } from 'notistack'
import Logs from '../../components/General/LogDetail'

const TableroDetailsAll = () => {
    const [spiner, setSpiner] = useState(false)
    const [data, setdata] = useState([])
    const [totalRows, setTotalRows] = useState(0)
    const { enqueueSnackbar } = useSnackbar()

    const getTableroXArea = useCallback(async (id, pege, perpage, search) => {
        setSpiner(true)
        const resp = await ConfiguracionLogic.tableroXAreasBiLogic(id, pege, perpage, search)
        if (resp.success) {
            setdata(resp.data)
            setTotalRows(resp.totalRows)
        }
        enqueueSnackbar(resp.message, {
            variant: resp.variant,
            anchorOrigin: {
                vertical: 'top',
                horizontal: 'right'
            }
        })
        setSpiner(false)
        setSpiner(false)
    }, [enqueueSnackbar])

    useEffect(() => {
        getTableroXArea(0, 1, 5)
    }, [getTableroXArea])

    const handleRedirectBack = (item) => {
        localStorage.removeItem('idAreaBI')
        localStorage.removeItem('nombreBI')
        localStorage.removeItem('descripcionBI')
        localStorage.removeItem('urlTableroBi')
        localStorage.setItem('returnBiDEtail', 2)
        window.location.href = global.TABLERO_LIST
    }

    const handleSearch = (item) => {
        getTableroXArea(0, 1, 50, item)
        // Lógica para eliminar el elemento
    }

    const handlePageChange = (page, perPage) => {
        getTableroXArea(0, page, perPage, '')
    }

    const columns = ['Nombre', 'Descripcion','Area']

    const handleWatch = async (item) => {
        localStorage.setItem('idTableoBI', item.id)
        localStorage.setItem('nombreBI', item.nombreTablero)
        localStorage.setItem('descripcionBI', item.Descripcion)
        localStorage.setItem('urlTableroBi', item.urlTablero)
        localStorage.setItem('pageOp', 2);
        Logs.logDetail(localStorage.getItem('secuenciaUsuario'), "click Dashboard id: " + item.id, 'vizualizar tablero: ' + item.nombreTablero, '/detalle-tableros', localStorage.getItem('codigoUsuario'))
        window.location.href = global.TABLERO_DETAILBI
    }

    return (
        <div>
            <Spiner opt={spiner} />
             {/*<section className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                       <div className="col-sm-6">
                            <button className="btn btn-default" onClick={handleRedirectBack}>
                                <i className="fas fa-arrow-left"></i> Regresar al listado de areas
                            </button>
    </div>
                        <div className="col-sm-6">
                            <ol className="breadcrumb float-sm-right">
                                <li className="breadcrumb-item">Tableros</li>
                            </ol>
                        </div>
                    </div>
                </div>
            </section>*/}
            <section className="content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-12">
                            <div className="card">
                                <br />
                                <div className="card-body">
                                    <DynamicTable
                                        columns={columns}
                                        data={data}
                                        onWatch={handleWatch}
                                        onSearch={handleSearch}
                                        onPageChange={handlePageChange}
                                        totalRows={totalRows}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div >
    )
}

export default TableroDetailsAll
